import { render, staticRenderFns } from "./ProjectWindow.vue?vue&type=template&id=05110f7c&scoped=true&lang=pug&"
import script from "./ProjectWindow.vue?vue&type=script&lang=ts&"
export * from "./ProjectWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05110f7c",
  null
  
)

export default component.exports